module.exports = __webpack_public_path__ + "static/full-9c4e49cdc804b0acf100d865e54e90e7.jpg";